import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button } from "@mui/material";
import launchDeeplink from "./DeeplinkLauncher";
import { useEffect, useState } from "react";

const DeeplinkHistory = (props) => {
  const allDeeplinkUseCase = props.allDeeplinkUseCase;
  const openDialog = props.openDialog;
  const handleClose = props.handleClose;

  const [allDeeplinks, setAllDeeplinks] = useState([]);

  useEffect(() => {
    const deeplinks = allDeeplinkUseCase.getDeeplinks();
    setAllDeeplinks(deeplinks);
  }, [allDeeplinkUseCase]);

  const clearHistory = () => {
    allDeeplinkUseCase.clearDeeplinks();
    setAllDeeplinks([]);
  };

  return (
    <div>
      <Dialog fullScreen open={openDialog} onClose={handleClose}>
        <AppBar
          sx={{
            position: "relative",
            boxShadow: "none",
            backgroundImage: "none",
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              History
            </Typography>
            <Button autoFocus color="inherit" onClick={clearHistory}>
              Clear history
            </Button>
          </Toolbar>
        </AppBar>
        {allDeeplinks.length > 0 ? (
          <List sx={{ p: 0 }}>
            {allDeeplinks.map((item, index) => (
              <div key={index}>
                <ListItemButton
                  onClick={() => {
                    launchDeeplink(item);
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        variant="body1"
                        sx={{
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {item}
                      </Typography>
                    }
                  />
                </ListItemButton>
                <Divider />
              </div>
            ))}
          </List>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              textAlign: "center",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              No deeplinks were executed.
            </Typography>
          </Box>
        )}
      </Dialog>
    </div>
  );
};

export default DeeplinkHistory;
